import React from "react";
import { Footer, Header, Notification } from "../Components";
import s from "./Public.module.css";
import ErrorBoundary from "../Components/ErrorBoundary";

const Public = ({ children }) => (
  <div className="d-flex flex-column">
    <Notification />
    <Header />
    <ErrorBoundary>
      <div className={s.children_container}>{children}</div>
    </ErrorBoundary>
    <Footer />
  </div>
);

export default Public;
